import { useMutation, useQuery } from "@tanstack/react-query";
import {
  internalInvoicesApi,
  InternalInvoiceDetail,
  ListInternalInvoicesQuery,
  ListInternalInvoicesResponse,
} from "services/internalInvoicesApi";
import { InvoiceDownloadResponse } from "services/billingApi";

const DEFAULT_LIST_PARAMS: ListInternalInvoicesQuery = { limit: 25 };

const internalInvoicesKey = (params: ListInternalInvoicesQuery) => [
  "internal",
  "invoices",
  params,
];

/**
 * Cross-company invoices for the internal/admin console (VERA-882). Stripe's
 * global list is cursor-based (no total), so callers paginate via startingAfter
 * (see InternalInvoicesPage's pageCursors handling — mirrors the per-company
 * billing Invoices table).
 */
export const useInternalInvoices = (
  params: ListInternalInvoicesQuery = DEFAULT_LIST_PARAMS
) =>
  useQuery<ListInternalInvoicesResponse>({
    queryKey: internalInvoicesKey(params),
    queryFn: () => internalInvoicesApi.listInvoices(params),
    staleTime: 30_000,
  });

export const useInternalInvoice = (invoiceId?: string) =>
  useQuery<InternalInvoiceDetail | null>({
    queryKey: ["internal", "invoice", invoiceId],
    queryFn: () =>
      invoiceId ? internalInvoicesApi.getInvoice(invoiceId) : null,
    enabled: Boolean(invoiceId),
  });

export const useInternalInvoiceDownload = () =>
  useMutation<InvoiceDownloadResponse, unknown, string>({
    mutationFn: (invoiceId) =>
      internalInvoicesApi.getInvoiceDownloadUrl(invoiceId),
  });
